"use strict";
/* tslint:disable */

/* eslint-disable */

/*
 * Copyright 2019 NEM
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Catapult REST Endpoints
 * OpenAPI Specification of catapult-rest
 *
 * The version of the OpenAPI document: 1.0.3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

var _regeneratorRuntime = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HashLockRoutesApi = void 0;

var runtime = require("../runtime");

var models_1 = require("../models");
/**
 *
 */


var HashLockRoutesApi = /*#__PURE__*/function (_runtime$BaseAPI) {
  _inherits(HashLockRoutesApi, _runtime$BaseAPI);

  var _super = _createSuper(HashLockRoutesApi);

  function HashLockRoutesApi() {
    _classCallCheck(this, HashLockRoutesApi);

    return _super.apply(this, arguments);
  }

  _createClass(HashLockRoutesApi, [{
    key: "getHashLockRaw",
    value:
    /**
     * Gets the hash lock for a given hash.
     * Get hash lock information
     */
    function getHashLockRaw(requestParameters) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var queryParameters, headerParameters, response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(requestParameters.hash === null || requestParameters.hash === undefined)) {
                  _context.next = 2;
                  break;
                }

                throw new runtime.RequiredError('hash', 'Required parameter requestParameters.hash was null or undefined when calling getHashLock.');

              case 2:
                queryParameters = {};
                headerParameters = {};
                _context.next = 6;
                return this.request({
                  path: "/lock/hash/{hash}".replace("{".concat("hash", "}"), encodeURIComponent(String(requestParameters.hash))),
                  method: 'GET',
                  headers: headerParameters,
                  query: queryParameters
                });

              case 6:
                response = _context.sent;
                return _context.abrupt("return", new runtime.JSONApiResponse(response, function (jsonValue) {
                  return models_1.HashLockInfoDTOFromJSON(jsonValue);
                }));

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
    /**
     * Gets the hash lock for a given hash.
     * Get hash lock information
     */

  }, {
    key: "getHashLock",
    value: function getHashLock(hash) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.getHashLockRaw({
                  hash: hash
                });

              case 2:
                response = _context2.sent;
                _context2.next = 5;
                return response.value();

              case 5:
                return _context2.abrupt("return", _context2.sent);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
    /**
     * Gets the hash lock merkle for a given hash.
     * Get hash lock merkle information
     */

  }, {
    key: "getHashLockMerkleRaw",
    value: function getHashLockMerkleRaw(requestParameters) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var queryParameters, headerParameters, response;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(requestParameters.hash === null || requestParameters.hash === undefined)) {
                  _context3.next = 2;
                  break;
                }

                throw new runtime.RequiredError('hash', 'Required parameter requestParameters.hash was null or undefined when calling getHashLockMerkle.');

              case 2:
                queryParameters = {};
                headerParameters = {};
                _context3.next = 6;
                return this.request({
                  path: "/lock/hash/{hash}/merkle".replace("{".concat("hash", "}"), encodeURIComponent(String(requestParameters.hash))),
                  method: 'GET',
                  headers: headerParameters,
                  query: queryParameters
                });

              case 6:
                response = _context3.sent;
                return _context3.abrupt("return", new runtime.JSONApiResponse(response, function (jsonValue) {
                  return models_1.MerkleStateInfoDTOFromJSON(jsonValue);
                }));

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
    /**
     * Gets the hash lock merkle for a given hash.
     * Get hash lock merkle information
     */

  }, {
    key: "getHashLockMerkle",
    value: function getHashLockMerkle(hash) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var response;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.getHashLockMerkleRaw({
                  hash: hash
                });

              case 2:
                response = _context4.sent;
                _context4.next = 5;
                return response.value();

              case 5:
                return _context4.abrupt("return", _context4.sent);

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
    /**
     * Returns an array of hash locks.
     * Search hash lock entries
     */

  }, {
    key: "searchHashLockRaw",
    value: function searchHashLockRaw(requestParameters) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var queryParameters, headerParameters, response;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                queryParameters = {};

                if (requestParameters.address !== undefined) {
                  queryParameters['address'] = requestParameters.address;
                }

                if (requestParameters.pageSize !== undefined) {
                  queryParameters['pageSize'] = requestParameters.pageSize;
                }

                if (requestParameters.pageNumber !== undefined) {
                  queryParameters['pageNumber'] = requestParameters.pageNumber;
                }

                if (requestParameters.offset !== undefined) {
                  queryParameters['offset'] = requestParameters.offset;
                }

                if (requestParameters.order !== undefined) {
                  queryParameters['order'] = requestParameters.order;
                }

                headerParameters = {};
                _context5.next = 9;
                return this.request({
                  path: "/lock/hash",
                  method: 'GET',
                  headers: headerParameters,
                  query: queryParameters
                });

              case 9:
                response = _context5.sent;
                return _context5.abrupt("return", new runtime.JSONApiResponse(response, function (jsonValue) {
                  return models_1.HashLockPageFromJSON(jsonValue);
                }));

              case 11:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
    /**
     * Returns an array of hash locks.
     * Search hash lock entries
     */

  }, {
    key: "searchHashLock",
    value: function searchHashLock(address, pageSize, pageNumber, offset, order) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var response;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.searchHashLockRaw({
                  address: address,
                  pageSize: pageSize,
                  pageNumber: pageNumber,
                  offset: offset,
                  order: order
                });

              case 2:
                response = _context6.sent;
                _context6.next = 5;
                return response.value();

              case 5:
                return _context6.abrupt("return", _context6.sent);

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    }
  }]);

  return HashLockRoutesApi;
}(runtime.BaseAPI);

exports.HashLockRoutesApi = HashLockRoutesApi;